import React, { Component } from 'react';
import Gallery from '../molecules/Gallery';
import Map from '../molecules/Map';
import axios from 'axios';
import Lottie from 'react-lottie';
import { connect } from 'react-redux';

import animationData from '../assets/animations/loader.json';
import { apiBase } from '../data/api';

import { locationColour } from '../utils';
import LocationEnlistees from '../molecules/LocationEnlistees';
import LocationCollectionSite from '../molecules/LocationCollectionSite';
import LocationCollectedBy from '../molecules/LocationCollectedBy';
import LocationCollectionDate from '../molecules/LocationCollectionDate';
import LocationLGA from '../molecules/LocationLGA';
import LocationAcknowledgement from '../molecules/LocationAcknowledgement';
import LocationCampaignName from '../molecules/LocationCampaignName';
import LocationConflict from '../molecules/LocationConflict';
import LocationSignificance from '../molecules/LocationSignificance';

class LocationContent extends Component {

  constructor( props ) {
    super( props );
    this.state = {
      locationData: null,
      locationDataError: false,
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      let self = this;
      axios( {
        method: 'get',
        url: this.props.location + '.json',
        baseURL: `${apiBase}/plaques/`,
      } ).then( function ( response ) {
        self.setState( { locationData: response.data.nodes[ 0 ].node } );
      } )
      .catch( function ( error ) {
        self.setState( { locationDataError: true } );
      } );
    }
  }

  render() {
    if ( this.state.locationData && !this.state.locationDataError ) {
      return (
        <div className="LocationContent">
          <h1><span className="sample" style={{backgroundColor: locationColour(this.state.locationData.nid, this.props.locations)}}/>{this.state.locationData.title}</h1>
          <div className="details">
            <LocationCollectionSite locationData={this.state.locationData}/>
            <LocationCollectedBy locationData={this.state.locationData}/>
            <LocationCollectionDate locationData={this.state.locationData}/>
            <LocationLGA locationData={this.state.locationData}/>
            <LocationAcknowledgement locationData={this.state.locationData} locationColour={locationColour(this.state.locationData.nid, this.props.locations)}/>
            <LocationCampaignName locationData={this.state.locationData}/>
            <LocationConflict locationData={this.state.locationData}/>
            <LocationSignificance locationData={this.state.locationData}/>
          </div>
          <Map
            lat={this.state.locationData.latitude}
            long={this.state.locationData.longitude}/>
          <Gallery
            featuredImage={this.state.locationData.feature_image_1600w}
            images={this.state.locationData.photos_1600w}/>
          <LocationEnlistees locationData={this.state.locationData}/>
        </div>
      )
    } else if ( this.state.locationDataError ) {
      return (
        <p>Error loading data from API... Please try again later.</p>
      )
    } else {
      const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
      return (
        <div className="LocationContentLoading">
          <Lottie options={defaultOptions}
            height={60}
            width={60}/>
        </div>
      )
    }
  }
}

function mapStateToProps( state ) {
  return {
    locations: state.data.locations,
  };
}

export default connect( mapStateToProps )( LocationContent );
